/*
 * @Descripttion: svg列表
 * @version: 1.0.0
 * @Author: kun.zhang
 * @Date: 2021-09-01 10:42:39
 * @LastEditors: xiaona.wang
 * @LastEditTime: 2021-09-29 22:04:00
 */
/**
 * svg列表
 */
export const svgList = [
    {
        icon: 'EDM-add',
        label: 'EDM-add'
    },
    {
        icon: 'EDM-alarm',
        label: 'EDM-alarm'
    },
    {
        icon: 'EDM-assets',
        label: 'EDM-assets'
    },
    {
        icon: 'EDM-Basic-data',
        label: 'EDM-Basic-data'
    },
    {
        icon: 'EDM-batch',
        label: 'EDM-batch'
    },
    {
        icon: 'EDM-calendar',
        label: 'EDM-calendar'
    },
    {
        icon: 'EDM-detailed-list',
        label: 'EDM-detailed-list'
    },
    {
        icon: 'EDM-distribution',
        label: 'EDM-distribution'
    },
    {
        icon: 'EDM-edit',
        label: 'EDM-edit'
    },
    {
        icon: 'EDM-electrovalence',
        label: 'EDM-electrovalence'
    },
    {
        icon: 'EDM-enterprise',
        label: 'EDM-enterprise'
    },
    {
        icon: 'EDM-device-management',
        label: 'EDM-device-management'
    },
    {
        icon: 'EDM-export',
        label: 'EDM-export'
    },
    {
        icon: 'EDM-Fault-dictionary',
        label: 'EDM-Fault-dictionary'
    },
    {
        icon: 'EDM-go-online',
        label: 'EDM-go-online'
    },
    {
        icon: 'EDm-Historical-time',
        label: 'EDm-Historical-time'
    },
    {
        icon: 'EDM-initialization',
        label: 'EDM-initialization'
    },
    {
        icon: 'EDM-IOT-access',
        label: 'EDM-IOT-access'
    },
    {
        icon: 'EDM-IOT',
        label: 'EDM-IOT'
    },
    {
        icon: 'EDM-journal',
        label: 'EDM-journal'
    },
    {
        icon: 'EDM-knowledge-base',
        label: 'EDM-knowledge-base'
    },
    {
        icon: 'EDM-maintain',
        label: 'EDM-maintain'
    },
    {
        icon: 'EDM-menu',
        label: 'EDM-menu'
    },
    {
        icon: 'EDM-nspection',
        label: 'EDM-nspection'
    },
    {
        icon: 'EDM-operate',
        label: 'EDM-operate'
    },
    {
        icon: 'EDM-organize',
        label: 'EDM-organize'
    },
    {
        icon: 'EDM-Personnel-management',
        label: 'EDM-Personnel-management'
    },
    {
        icon: 'EDM-quit',
        label: 'EDM-quit'
    },
    {
        icon: 'EDM-repair',
        label: 'EDM-repair'
    },
    {
        icon: 'EDM-report-form',
        label: 'EDM-report-form'
    },
    {
        icon: 'EDM-setup',
        label: 'EDM-setup'
    },
    {
        icon: 'EDM-spare-part',
        label: 'EDM-spare-part'
    },
    {
        icon: 'EDM-Standing-book',
        label: 'EDM-Standing-book'
    },
    {
        icon: 'EDM-system',
        label: 'EDM-system'
    },
    {
        icon: 'Home',
        label: 'Home'
    },
    {
        icon: 'EDM-save',
        label: 'EDM-save'
    },
    {
        icon: 'EDM-suoxiao',
        label: 'EDM-suoxiao'
    },
    {
        icon: 'EDM-cutinot',
        label: 'EDM-cutinot'
    },
    {
        icon: 'EDM-failure',
        label: 'EDM-failure'
    },
    {
        icon: 'EDM-fangda',
        label: 'EDM-fangda'
    },
    {
        icon: 'EDM-organization',
        label: 'EDM-organization'
    },
    {
        icon: 'EDM-printer',
        label: 'EDM-printer'
    },
    {
        icon: 'EDM-Prompt',
        label: 'EDM-Prompt'
    },
    {
        icon: 'EDM-flow',
        label: 'EDM-flow'
    },
    {
      icon: 'EDM-message',
      label: 'EDM-message'
    }
];

// 工作台图标
export const workBenchList = 'accurateBom,inspectOrder,orderStatistic,alarmAnalysis,inspectStrategy,outhouseRecord,areaLocation,inventoryAccount,partsUsage,assessConfig,jobPost,repairDeceipt,assessScore,knowledgeDoc,repaireAnalysis,calendarConfig,knowlegeClass,repaireOrder,calendarPost,kpi,shiftPost,calendarTemplete,kpiClass,shiftSystem,equipmentAccount,locationPost,staffInfo,equipmentClass,maintainAnalysis,subitem,faultClass,maintainOrder,supperBom,faultMode,maintainPlan,supplierManage,faultReport,maintainStrategy,teamManage,faultSpread,materialApply,teamPost,housePost,materialClass,unit,inhouseRecord,matrialInfo,'.split(',').map(item => {
  return {
    icon: item,
    label: item
  }
})
